import { get } from './api';

export const blogAPI = {
  getBlogs() {
    return get('blogs');
  },

  getBlogById(id) {
    return get(`blog/${id}?only_layout=true`);
  }
};
